import React, {useState, useEffect} from 'react';
import '../App.css';
import {toast} from 'react-toastify';
import {Link, useLocation, useParams} from 'react-router-dom';
import {Select} from 'antd';
import api from '../Interceptor';
import {getRoute} from '../api/routes';
import GetCurrencySymbol from '../components/GetCurrencySymbol';
import User_ExpenseGraph from '../components/User_ExpenseGraph';
import useModal from '../hooks/useModal';
import AddExpense from './AddExpense';
import ExpenseListProjectDetail from '../components/ExpenseListProjectDetail';
import ExpenseGraph from '../components/ExpenseGraph';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';
import {useSelector} from 'react-redux';
const {Option} = Select;

const UserProjectDetail = () => {
  const user = useSelector((state) => state.auth.user);
  const access = localStorage.getItem('access');
  const location = useLocation();
  const {projectId: paramProjectId} = useParams();
  const projectId = location.state?.projectId || paramProjectId;
  const {projectname: paramProjectName} = useParams();
  const projectName = location.state?.projectName || paramProjectName;
  const baseCurrency = localStorage.getItem('baseCurrency');
  const [currencyView, setCurrencyView] = useState('ProjectCurrency');
  const [selectedDuration, setSelectedDuration] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [milestoneList, setMilestoneList] = useState([]);
  const [selectedMilestone, setSelectedMilestone] = useState('All');
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [netProfit, setNetProfit] = useState(0);
  const [addTransactionModalVisible, setAddTransactionModalVisible] =
    useState(false);
  const {isOpen, toggleModal} = useModal();
  const [projectCurrency, setProjectCurrency] = useState(null);
  console.log(
    '🚀 ~ UserProjectDetail ~ projectCurrency:',
    projectCurrency?._id
  );
  const fetchProjectDetails = async () => {
    try {
      const response = await api.get(
        `${getRoute(
          'users',
          user.userRole.name,
          'projects',
          false,
          false,
          ''
        )}?id=${projectId}`
      );
      setProjectCurrency(response.data[0].currency);
    } catch (error) {
      toast.error('Error fetching project details', error);
    }
  };
  useEffect(() => {
    if (projectId) {
      fetchProjectDetails();
      fetchMilestones(projectId);
    }
  }, [projectId, selectedMilestone]);
  const fetchMilestones = async () => {
    try {
      let url = `${getRoute('users', 'user', 'milestone', false, false, '')}`;

      url += `?projectId=${projectId}`;

      const response = await api.get(url);
      setMilestoneList(response.data);
    } catch (error) {
      toast.error('Error fetching milestones', error);
    }
  };
  const calculateDuration = (selectedDuration) => {
    const today = new Date();
    let newStartDate = '';
    let newEndDate = today.toISOString().split('T')[0];

    switch (selectedDuration) {
      case 'currentweek':
        const firstDayOfWeek = new Date(
          today.setDate(today.getDate() - today.getDay())
        );
        newStartDate = firstDayOfWeek.toISOString().split('T')[0];
        break;
      case 'last12months':
        const lastYear = new Date();
        lastYear.setFullYear(today.getFullYear() - 1);
        newStartDate = lastYear.toISOString().split('T')[0];
        break;
      case 'last6years':
        const last6Years = new Date();
        last6Years.setFullYear(today.getFullYear() - 6);
        newStartDate = last6Years.toISOString().split('T')[0];
        break;
      case 'all':
        newStartDate = '';
        break;
      default:
        newStartDate = '';
    }

    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };
  useEffect(() => {
    calculateDuration(selectedDuration);
  }, [selectedDuration]);
  const fetchExpenses = async (projectId, milestoneId, startDate, endDate) => {
    try {
      setLoading(true);

      let url = `${getRoute('users', 'user', 'expenses', false)}`;
      let params = [];
      if (projectId !== 'All') {
        params.push(`projectId=${projectId}`);
      }
      if (milestoneId !== 'All') {
        params.push(`milestoneId=${milestoneId}`);
      }
      if (startDate) {
        params.push(`startDate=${startDate}`);
      }
      if (endDate) {
        params.push(`endDate=${endDate}`);
      }
      if (params.length > 0) {
        url += `?${params.join('&')}`;
      }
      const response = await api.get(url);
      if (Array.isArray(response.data)) {
        setExpenses(response.data);
      } else {
        toast.error('Invalid data format received from the server.');
        setExpenses([]);
      }
    } catch (error) {
      toast.error('Failed to fetch expenses.');
    } finally {
      setLoading(false);
    }
  };
  const handleSuccess = () => {
    fetchExpenses();
  };
  useEffect(() => {
    if (projectId) {
      setTotalIncome(0);
      setTotalExpense(0);
      setNetProfit(0);

      fetchMilestones(projectId);
      fetchExpenses(projectId, selectedMilestone);
    }
  }, [projectId, selectedMilestone]);

  const calculateTotals = (expenses, currencyView) => {
    let income = 0;
    let expense = 0;

    expenses.forEach((exp) => {
      if (exp.type === 'income') {
        income +=
          currencyView === 'BaseCurrency'
            ? exp.amount / exp.conversionRate
            : exp.amount;
      } else if (exp.type === 'expense') {
        expense +=
          currencyView === 'BaseCurrency'
            ? exp.amount / exp.conversionRate
            : exp.amount;
      }
    });

    setTotalIncome(income);
    setTotalExpense(expense);
    setNetProfit(income - expense + 1);
  };
  useEffect(() => {
    if (expenses.length > 0) {
      calculateTotals(expenses, currencyView, baseCurrency);
    }
  }, [expenses, currencyView]);
  useEffect(() => {
    if (projectId && selectedMilestone && startDate && endDate) {
      fetchExpenses(projectId, selectedMilestone, startDate, endDate);
    }
  }, [projectId, selectedMilestone, startDate, endDate]);
  const handleDurationChange = (value) => {
    setSelectedDuration(value);

    calculateDuration(selectedDuration);
  };
  const handleMilestoneChange = (value) => {
    setSelectedMilestone(value);
  };
  const handleCurrencyChange = (value) => {
    setCurrencyView(value);
  };
  if (loading)
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  return (
    <div className="min-h-screen flex flex-col p-3 gap-2 overflow-hidden font-customFont">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div style={{fontFamily: 'Noto Serif, sans-serif'}}>
          <h1 className="font-bold text-lg md:text-xl">{projectName}</h1>
        </div>
        <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto mt-3 md:mt-0">
          {access === process.env.REACT_APP_ACCESS_EDIT ? (
            <button
              className="bg-themeGradient text-white hover:bg-themeGradientHover px-3 py-1 rounded-md flex items-center justify-center w-full"
              onClick={toggleModal}
            >
              <i className="fa-solid fa-plus text-lg"></i>
              <span className="ms-2">New Transaction</span>
            </button>
          ) : null}
        </div>
      </div>
      {isOpen ? (
        <AddExpense
          onSuccess={handleSuccess}
          onCancel={toggleModal}
          isModalOpen={isOpen}
          projectId={projectId}
        />
      ) : null}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {/* Total Net Income Card */}{' '}
        <div className="group relative overflow-hidden border border-blue-200 bg-gradient-to-br from-blue-50 via-white to-blue-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col sm:col-span-2 lg:col-span-1">
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faWallet}
                  className="text-white text-md"
                />
              </div>
              <p className="text-blue-700 text-sm font-semibold uppercase tracking-wide">
                Net Income
              </p>
            </div>
          </div>
          <p className="text-blue-900 text-3xl font-bold mt-1 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{' '}
            <span>{Math.floor(netProfit).toLocaleString()}</span>
            <span className="text-blue-600 text-xl">
              .{netProfit.toFixed(2).split('.')[1]}
            </span>
          </p>
          <p className="text-blue-600 text-xs mt-1 font-medium">
            Total profit after expenses
          </p>
        </div>
        {/* Total Income Card */}{' '}
        <div className="group relative overflow-hidden border border-green-200 bg-gradient-to-br from-green-50 via-white to-green-100 shadow-lg  transition-all duration-300 rounded-xl p-4 pb-3 flex flex-col ">
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendUp}
                  className="text-white text-md"
                />
              </div>
              <p className="text-green-700 text-sm font-semibold uppercase tracking-wide">
                Income
              </p>
            </div>
          </div>
          <p className="text-green-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{' '}
            <span>{Math.floor(totalIncome).toLocaleString()}</span>
            <span className="text-green-600 text-xl">
              .{totalIncome.toFixed(2).split('.')[1]}
            </span>
          </p>
          <p className="text-green-600 text-xs mt-1 font-medium">
            Total earnings received
          </p>
        </div>
        {/* Total Expense Card */}{' '}
        <div className="group relative overflow-hidden border border-red-200 bg-gradient-to-br from-red-50 via-white to-red-100 shadow-lg transition-all duration-300 rounded-2xl p-4 pb-3 flex flex-col">
          <div className="absolute top-0 right-0 w-32 h-32 bg-red-200 rounded-full -mr-16 -mt-16 opacity-20"></div>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center shadow-md">
                <FontAwesomeIcon
                  icon={faArrowTrendDown}
                  className="text-white text-md"
                />
              </div>
              <p className="text-red-700 text-sm font-semibold uppercase tracking-wide">
                Expense
              </p>
            </div>
          </div>
          <p className="text-red-900 text-3xl font-bold mt-2 relative z-10">
            <GetCurrencySymbol currencyId={baseCurrency} />{' '}
            <span>{Math.floor(totalExpense).toLocaleString()}</span>
            <span className="text-red-600 text-xl">
              .{totalExpense.toFixed(2).split('.')[1]}
            </span>
          </p>
          <p className="text-red-600 text-xs mt-1 font-medium">
            Total amount spent
          </p>
        </div>
      </div>
      <div className="w-full bg-white rounded-lg border border-[#E5E7EB] shadow-sm p-3">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-semibold font-customFont">Overview</p>

          <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto font-customFont">
            <Select
              defaultValue="All"
              id="filterMilestone"
              value={selectedMilestone}
              onChange={(value) => handleMilestoneChange(value)}
              className={`ring-1 rounded-md w-full sm:w-40 ${
                selectedMilestone || selectedMilestone === 'All'
                  ? ''
                  : 'ring-blue-400'
              }`}
            >
              <Option value="All">All Milestones</Option>
              {milestoneList.map((mile) => (
                <Option key={mile._id} value={mile._id}>
                  {mile.name}
                </Option>
              ))}
            </Select>
            {/* Duration Filter Dropdown */}
            <Select
              defaultValue="All"
              required
              value={selectedDuration}
              onChange={handleDurationChange}
              onBlur={() => {
                if (!selectedDuration) setSelectedDuration('');
              }}
              className={`w-full sm:w-40 ${
                selectedDuration ? 'ring-1 ring-blue-400 rounded-md' : ''
              }`}
            >
              <Option value="currentweek">This Week</Option>
              <Option value="last12months">Last 12 Months</Option>
              <Option value="last6years">Last 6 Years</Option>
              <Option value="all">All</Option>
            </Select>
          </div>
        </div>

        {/* Expense Graph - Added explicit height */}
        <div className="mt-4 h-[300px] md:h-[350px] lg:h-[400px]">
          <ExpenseGraph
            selectedProject={projectId}
            selectedMilestone={selectedMilestone}
            selectedDuration={selectedDuration}
            startDate={startDate}
            endDate={endDate}
            projectCurrency={projectCurrency?._id}
          />
        </div>
      </div>
      <div>
        <ExpenseListProjectDetail
          selectedMilestone={selectedMilestone}
          selectedProject={projectId}
        />
      </div>
    </div>
  );
};

export default UserProjectDetail;
